import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Cookies from "js-cookie";

import Purple_Btn from "../../../common_components/common_btn/purple_btn/Purple_Btn";
import { preferedDeliveryDate } from "../../../../utils/apis/Home/Homeapi";
import { getBespokeProgress, postBespokeStep1 } from "../../../../utils/apis/BespokeGift/bespoke_gift";
// import { postStep1 } from "../../../../utils/apis/giftOrderApi";

function Step_1({ handleNext }) {
  const [preferedDates, setPreferedDates] = useState([]);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState(null);

  const {
    register,
    handleSubmit,
    control,
    watch, reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      email: "",
      contact_no: "",
      delivery_address: "",
      delivery_date_id: "",
      delivery_date: "",
    },
  });

  const selectedDeliveryDateId = watch("delivery_date_id");

  const getAllPreferedDates = async () => {
    const res = await preferedDeliveryDate();
    if (res?.success) {
      const data = [
        ...res.data,
        { name: "Specific Date", id: "specific_date" },
      ];
      setPreferedDates(data);

      if (res?.data?.length > 0) {
        setValue("delivery_date_id", String(res.data[0].id));
      }
    } else {
      console.error("Error fetching preferred dates:", res?.error);
    }
  };

  useEffect(() => {
    getAllPreferedDates();
  }, []);

  const onSubmit = async (data) => {
    setLoading(true);
    setApiError(null);

    try {
      const isSpecificDate = data.delivery_date_id === "specific_date";

      const payload = {
        name: data.name,
        email: data.email,
        contact_no: data.contact_no,
        delivery_address: data.delivery_address,
        delivery_date: isSpecificDate ? data.delivery_date : null,
        delivery_date_id: isSpecificDate ? null : Number(data.delivery_date_id),
        status: 1,
      };
      if (data?.id) {
        payload.draft_id = data?.id
      }
      const res = await postBespokeStep1(payload);

      if (res?.success) {
        Cookies.set("draftId", res?.data?.draftId, { expires: 1 });
        handleNext({ draftId: res?.data?.draftId, step1: payload });
      }
    } catch (err) {
      setApiError(err?.message || "Failed to save. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {

    const draftId = Cookies.get("draftId");

    if (!draftId) return;

    const fetchDraft = async () => {
      try {
        const res = await getBespokeProgress(draftId);

        if (res?.success) {

          const data = {
            ...res.data,
            delivery_date_id: res?.data?.delivery_date_id ? String(res?.data?.delivery_date_id) : null,
            delivery_date: res?.data?.delivery_date
              ? new Date(res.data.delivery_date).toISOString().split("T")[0]
              : null
          };

          reset(data);

          if (data?.delivery_date) {
            setValue("delivery_date_id", "specific_date")
            setShowDatePicker(true)
          }
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDraft();

  }, []);

  return (
    <section className="step_form_content">
      <Form>
        <Row className="gy-4">

          <Col md={12}>
            <Form.Group className="form_group">
              <Form.Label>Enter Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Name"
                isInvalid={!!errors.name}
                {...register("name", {
                  required: "Full name is required",
                  minLength: {
                    value: 3,
                    message: "Name must be at least 3 characters",
                  },
                  maxLength: {
                    value: 50,
                    message: "Name cannot exceed 50 characters",
                  },
                  pattern: {
                    value: /^[A-Za-z\s]+$/,
                    message: "Name can only contain letters and spaces",
                  },
                })}
              />
              <Form.Control.Feedback type="invalid">
                {errors.name?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={12}>
            <Form.Group className="form_group">
              <Form.Label>Enter Email Address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter Email Address"
                isInvalid={!!errors.email}
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
                    message: "Enter a valid email address",
                  },
                })}
              />
              <Form.Control.Feedback type="invalid">
                {errors.email?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={12}>
            <Form.Group className="form_group">
              <Form.Label>Contact*</Form.Label>
              <div className="contact_row">
                <Controller
                  name="contact_no"
                  control={control}
                  rules={{
                    required: "Phone number is required",
                    minLength: { value: 7, message: "Enter a valid phone number" },
                  }}
                  render={({ field: { onChange, value } }) => (
                    <PhoneInput
                      country={"in"}
                      value={value}
                      onChange={onChange}
                      placeholder="Enter Contact Number"
                      inputClass={`phone_input ${errors.contact_no ? "is-invalid" : ""}`}
                      buttonClass="phone_btn"
                      containerClass="phone_container"
                    />
                  )}
                />
                {errors.contact_no && (
                  <div className="invalid-feedback d-block mt-1">
                    {errors.contact_no.message}
                  </div>
                )}
              </div>
            </Form.Group>
          </Col>

          <Col md={12}>
            <Form.Group className="form_group">
              <Form.Label>Delivery Address</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Delivery Address"
                isInvalid={!!errors.delivery_address}
                {...register("delivery_address", {
                  required: "Delivery address is required",
                })}
              />
              <Form.Control.Feedback type="invalid">
                {errors.delivery_address?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={12}>
            <Form.Group className="form_group">
              <Form.Label>Preferred Delivery Date</Form.Label>

              {errors.delivery_date_id && (
                <div className="invalid-feedback d-block mb-2">
                  {errors.delivery_date_id.message}
                </div>
              )}

              <div className="delivery_options">
                {preferedDates?.map((item) => (
                  <div className="delivery_box" key={item?.id}>
                    <Form.Check
                      type="radio"
                      id={`delivery-${item?.id}`}
                      name="delivery_date_id"
                      label={item?.name}
                      value={String(item?.id)}
                      checked={selectedDeliveryDateId === String(item?.id)}
                      onChange={() => {
                        const val = String(item?.id);
                        setValue("delivery_date_id", val, { shouldValidate: true });
                        setValue("delivery_date", ""); // clear specific date when switching
                        setShowDatePicker(val === "specific_date");
                      }}
                    />
                  </div>
                ))}

                <input
                  type="hidden"
                  {...register("delivery_date_id", {
                    required: "Please select a preferred delivery date",
                  })}
                />
              </div>
            </Form.Group>
          </Col>

          {showDatePicker && (
            <Col md={4}>
              <Form.Group className="form_group">
                <Form.Label>Select Date</Form.Label>
                <Form.Control
                  type="date"
                  min={new Date(Date.now() + 6 * 24 * 60 * 60 * 1000).toISOString().split("T")[0]}
                  isInvalid={!!errors.delivery_date}
                  {...register("delivery_date", {
                    validate: (val) =>
                      selectedDeliveryDateId !== "specific_date" ||
                      !!val ||
                      "Please pick a specific date",
                  })}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.delivery_date?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          )}

        </Row>

        {/* API-level error */}
        {apiError && (
          <div className="alert alert-danger mt-3 py-2" role="alert">
            {apiError}
          </div>
        )}

        <div className="btn_holder">
          <Purple_Btn
            onClick={handleSubmit(onSubmit)}
            type="submit"
            btnText={loading ? "Saving..." : "Proceed"}
            disabled={loading}
          />
        </div>
      </Form>
    </section>
  );
}

export default Step_1;